import React, { Dispatch } from 'react';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import SideNavMenuItemContainer from '../SideNavMenuItem/SideNavMenuItemContainer';
import { ISideNavItem } from '../HBSideNav';

const StyledFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: ${colors.neutral100};
    position: relative;
`;

interface ISideNavFooter {
    footerMenuItems: ISideNavItem[];
    selectedItem: string | null;
    selectedSubItem: string | null;
    handleItemClick: (
        e: React.MouseEvent<HTMLElement, MouseEvent>,
        details: {
            item: ISideNavItem;
            parentLabel?: ISideNavItem['label'];
            source?: 'sidenav' | 'popover';
        }
    ) => void;
    persistentItemOpen?: ISideNavItem;
    setPersistentItemOpen?: Dispatch<ISideNavItem>;
    footerTitle?: () => JSX.Element;
}

function SideNavFooter({
    footerMenuItems,
    handleItemClick,
    persistentItemOpen,
    setPersistentItemOpen,
    footerTitle: FooterTitle
}: ISideNavFooter) {
    return (
        <StyledFooter>
            {FooterTitle && <FooterTitle />}
            {footerMenuItems.map(item => (
                <SideNavMenuItemContainer
                    key={item.label}
                    menuItem={item}
                    onMenuItemClick={handleItemClick}
                    persistentItemOpen={persistentItemOpen}
                    setPersistentItemOpen={setPersistentItemOpen}
                />
            ))}
        </StyledFooter>
    );
}

export default SideNavFooter;
